import React, { useState, useEffect } from "react";
import { ArrowRightCircle } from "lucide-react";
import { motion } from 'framer-motion';
import AppointmentModal from "./AppointmentModal";
import { useNavigate } from "react-router-dom";

const LandingSection: React.FC = () => {
    const [currentText, setCurrentText] = useState("Individuals");
    const textCycle = ["Individuals", "Couples", "Professionals", "Family"];


    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const navigate = useNavigate();


    useEffect(() => {
        const interval = setInterval(() => {
            const currentIndex = textCycle.indexOf(currentText);
            const nextIndex = (currentIndex + 1) % textCycle.length;
            setCurrentText(textCycle[nextIndex]);
        }, 2000);

        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, [currentText]);

    return (
        <section className="curvy-bg-container relative h-[80vh] md:min-h-screen flex flex-col md:flex-row overflow-hidden bg-gradient-to-br from-orange-400 to-orange-300">
            {/* Background layers */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-teal-800 to-teal-300 rounded-br-[100%] z-0"></div>
            {/*<div className="absolute top-0 right-0 w-full h-full bg-contain bg-no-repeat bg-right-top opacity-10 md:opacity-20 z-0" style={{ backgroundImage: "url('/images/help.png')" }}></div> */}

            <div className="w-full md:w-7/12 z-10 flex items-center text-center mt-28 md:mt-0 text-center px-6 md:pl-28 md:pr-0 relative">
                <div className="max-w-3xl w-full md:space-y-6 mt-28 md:mt-20">
                    {/*}  <motion.div
                        // initial={{ opacity: 0, x: -50 }}
                        // animate={{ opacity: 1, x: 0 }}
                        // transition={{ duration: 0.6, delay: 0.3 }}
                        className="bg-white/20 inline-block px-4 py-2 rounded-full"
                    >
                        <span className="text-white text-sm font-medium">Compassionate Mental Health Support</span>
                    </motion.div>*/}

                    {/*  <motion.h2
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={{ opacity: 1, y: 0 }}
                        // transition={{ duration: 0.6, delay: 0.6 }}
                        className="text-xl md:text-3xl text-white font-light"
                    >
                        Empowering Mental Wellness
                    </motion.h2>*/}

                    <motion.h1
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={{ opacity: 1, y: 0 }}
                        // transition={{ duration: 0.6, delay: 0.9 }}
                        className="text-4xl md:text-6xl text-white font-bold text-center"
                    >
                        Human-First Mental Health Care
                    </motion.h1>

                    {/* <AnimatePresence mode="wait">
                        <motion.h1
                            // key={currentText}
                            // initial={{ opacity: 0, y: 20 }}
                            // animate={{ opacity: 1, y: 0 }}
                            // exit={{ opacity: 0, y: -20 }}
                            // transition={{ duration: 0.6 }}
                            className="text-5xl md:text-5xl text-white font-black tracking-tight"
                        >
                            {currentText}
                        </motion.h1> 
                    </AnimatePresence> */}

                     <motion.p
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={{ opacity: 1, y: 0 }}
                        // transition={{ duration: 0.6, delay: 1.5 }}
                        className="hidden md:block text-white/90 text-center text-xl md:text-3xl max-w-full md:max-w-3xl pt-4"
                    >
                        We care for our therapists, so they can care for you.

                    </motion.p>

                    <motion.p
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={{ opacity: 1, y: 0 }}
                        // transition={{ duration: 0.6, delay: 1.5 }}
                        className="md:hidden block text-white/90 text-center text-xl max-w-full pt-10"
                    >
                        We care for our therapists, 

                    </motion.p>
                     <motion.p
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={{ opacity: 1, y: 0 }}
                        // transition={{ duration: 0.6, delay: 1.5 }}
                        className="block md:hidden text-white/90 text-center text-xl md:text-3xl max-w-full"
                    >
                        So they can care for you.

                    </motion.p>

                    <motion.div
                        className="pt-8 space-y-6"
                    // initial={{ opacity: 0, y: 20 }}
                    // animate={{ opacity: 1, y: 0 }}
                    // transition={{ duration: 0.6, delay: 2.7 }}
                    >
                        <button
                            className="bg-white text-teal-700 flex items-center justify-center text-center px-6 py-3 text-sm md:text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all w-full md:w-auto mx-auto"
                            onClick={() => navigate("/book-appointment")}
                        >
                            Request Therapy Session
                            <ArrowRightCircle className="ml-3 w-7 h-7 text-teal-700" />
                        </button>

                        {/* Mobile Image Section *
                        <motion.div
                            className="block md:hidden w-full h-96 md:h-full"
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={{ opacity: 1, y: 0 }}
                        // transition={{ duration: 0.9, delay: 3 }}
                        >
                            <img
                                src="/images/help.png"
                                alt="therapy support"
                                className="w-full h-full object-cover rounded-xl opacity-80"
                            />
                        </motion.div>*/}
                    </motion.div>
                </div>
            </div>

            <AppointmentModal isOpen={isModalOpen} onClose={closeModal} />

            {/* Desktop Image Section */}
            <motion.div
                className="hidden md:block absolute top-0 right-0 w-5/12 h-full z-0"
            // initial={{ opacity: 0, x: 50 }}
            // animate={{ opacity: 1, x: 0 }}
            // transition={{ duration: 0.9, delay: 3 }}
            >
                <img
                    src="/images/help.png"
                    alt="therapy support"
                    className="absolute inset-0 w-full h-full object-cover opacity-70"
                />
            </motion.div>
        </section>
    );
};

export default LandingSection;